import { ReactComponent as CloseForm } from './images/close-message.svg';
import './ImageModal.css';
import { useState } from 'react';
import noImageIcon from './images/no-image.svg';

function ImageModal(props) {
  const [isVertical, setIsVertical] = useState(null);

  const handleImageLoad = (event) => {
    const { naturalWidth, naturalHeight } = event.target;
    naturalWidth > naturalHeight ? setIsVertical(false) : setIsVertical(true);
  };

  const geoUrl = process.env.REACT_APP_GEOSERVER;

  return (
    <div className="image-modal">
      <div className="image-modal-shadow" onClick={props.closeModal}></div>

      <div className="image-modal-container">
        <div className="im-header">
          <div className="im-header-title">{props.title}</div>
          <button
            style={{ fontWeight: 'bolder' }}
            className="im-close-button"
            onClick={props.closeModal}
          >
            <CloseForm style={{ height: '10px' }} />
          </button>
        </div>
        <div
          className={isVertical ? 'im-vertical-image' : 'im-horizontal-image'}
        >
          <img
            src={`${geoUrl}/static/${props.folder}/${props.image}`}
            onLoad={handleImageLoad}
            alt="problem"
            style={{
              height: '100%',
              width: '100%',
              objectFit: 'cover',
              borderBottomRightRadius: '16px',
              borderBottomLeftRadius: '16px',
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default ImageModal;
